export const WEB_URL = 'https://www.moneyhoon.sk/';
export const TERMS_AND_CONDITIONS_URL = 'https://moneyhoon.sk/pravidla-a-podmienky-pouzivania';
export const DATA_PROTECTION_POLICY_URL = 'https://moneyhoon.sk/ochrana-osobnych-udajov';
export const LOGO_SIZE = 24;
export const PRODUCT_START_FLOW_ENABLED = true;
